export type SyncPushStatus =
  | 'accepted'
  | 'rejected-stale'
  | 'rejected-forbidden'
  | 'rejected-bulk-delete'
  | 'rejected-shrink'
  | 'skipped-invalid';

const LOCAL_ONLY_SYNC_DOMAINS = new Set([
  'changfa_share_templates', // 通过独立版本校验接口保存，停止旧整份同步。
  'changfa_cloud_print_settings',
  // 2026-09-29 阶段 5：进货明细已迁到 MySQL 独立表（inbound_orders / inbound_order_items），
  // 停止该域的跨设备推送/拉取，避免 localStorage 与 MySQL 两边各改各的（参数分家）。
  // 本地 localStorage 仅作为离线兜底缓存保留，数据源以服务端为准。
  'changfa_purchase_details',
]);

export function isLocalOnlySyncDomain(domain: string): boolean {
  return LOCAL_ONLY_SYNC_DOMAINS.has(domain);
}

export function buildSyncHeaders(token: string): Record<string, string> {
  if (!token) throw new Error('请先登录后再同步');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export function isSettledPushStatus(status: SyncPushStatus | undefined): boolean {
  return status === 'accepted'
    || status === 'rejected-stale'
    || status === 'rejected-forbidden'
    || status === 'rejected-bulk-delete'
    || status === 'rejected-shrink'
    || status === 'skipped-invalid';
}
